export const T = {
  en_GB: {
    noGoalsYet: "No goals yet",
    createGoalsDescription:
      "Create goals to define investment objectives with schedules and portfolios.",
    addFirstGoal: "Add First Goal",
    addGoal: "Add Goal",
    delete: "Delete",
  },
  nb_NO: {
    noGoalsYet: "Ingen mål ennå",
    createGoalsDescription:
      "Opprett mål for å definere investeringsmål med tidsplaner og porteføljer.",
    addFirstGoal: "Legg til første mål",
    addGoal: "Legg til mål",
    delete: "Slett",
  },
} as const;
